import React from 'react';
import FieldModal from '../../../components/modals/fieldModal';
import InputField from '../../../components/inputs/inputField';
import TimeField from '../../../components/inputs/timeField';


class ViewSubmissionModal extends React.Component {
	parseAdditionalAttendees = (rawAttendees) => {
		let parsed = [];
		if (!rawAttendees) return parsed;
		if (Array.isArray(rawAttendees)) {
			parsed = rawAttendees;
		} else if (typeof rawAttendees === 'string') {
			try {
				const p = JSON.parse(rawAttendees);
				parsed = Array.isArray(p) ? p : [];
			} catch (e) {
				parsed = [];
			}
		}
		const attendeeFieldsToNormalize = {
			_attendeeFirstName: true,
			_attendeeLastName: true,
			_attendeeEmail: true,
		};
		return parsed.map((attendee) =>
			Object.fromEntries(
				Object.entries(attendee).map(([key, value]) => [
					attendeeFieldsToNormalize[key] ? key.slice(1) : key,
					value,
				])
			)
		);
	};

	render() {
		const { isOpen, toggle, request, program } = this.props;

		if (!request) return null;

		const eventDefaultDetails = program.eventDefaults?.details || {};
		const additionalAttendees = this.parseAdditionalAttendees(request.additionalAttendees);

		const salesforceCustomFields = (request.integrations?.salesforce?.customFields || []).filter(
			(field) => field.value && field.value !== ''
		);
		const salesforceAdditionalAttendees = request.integrations?.salesforce?.additionalAttendees || [];

		return (
			<div>
				<FieldModal
					size="medium"
					isOpen={isOpen}
					modalTitle={'Request Submission'}
					bodyDescription={''}
					bodyContent={() => {
						return (
							<div className="modalBodySubmission sectionBody">
								<div className="sectionBlock">
									<InputField
										label="Submitter Name"
										value={request.submitterName}
										disabled={true}
									/>
									<InputField
										label="Submitter Email"
										value={request.submitterEmail}
										disabled={true}
									/>
									<InputField
										label="Requested Event Name"
										value={request.name}
										disabled={true}
									/>
									<div className="flex-sb w-100">
										<InputField
											label="Start Date"
											type="date"
											classes="mr-10"
											value={request.startDate}
											disabled={true}
										/>
										<InputField
											label="End Date"
											type="date"
											classes="ml-10"
											value={request.endDate}
											disabled={true}
										/>
									</div>
									<div className="flex-sb w-100">
										<TimeField
											label="Start Time"
											classes="mr-10 w-100"
											value={request.startTime}
											disabled={true}
										/>
										<TimeField
											label="End Time"
											classes="ml-10 w-100"
											value={request.endTime}
											disabled={true}
										/>
									</div>

									<InputField
										label="Timezone"
										value={request.timezone}
										disabled={true}
									/>
									{request.availabilityCalendar && (
										<InputField
											label="Requested Calendar"
											value={request.availabilityCalendar}
											disabled={true}
										/>
									)}
								</div>

								{(() => {
									if (!program.eventCustomFields) return null;
									const requiredCustomFields = eventDefaultDetails.requiredCustomFields || [];
									let fieldElements = [];
									program.eventCustomFields.forEach((category) => {
										category.fields.forEach((field) => {
											if (
												requiredCustomFields.includes(field._id) &&
												request[field._id] &&
												request[field._id] !== ''
											) {
												fieldElements.push(
													<InputField
														key={field._id}
														label={field.fieldName}
														type={field.fieldType}
														value={request[field._id]}
														disabled={true}
													/>
												);
											}
										});
									});
									if (fieldElements.length === 0) return null;
									return (
										<div className="sectionBlock">
											<h2 className="blockHeader">Custom Fields</h2>
											{fieldElements}
										</div>
									);
								})()}

								{(() => {
									if (!program.fieldLabels) return null;
									let fieldElements = [];
									Object.keys(program.fieldLabels).forEach((field) => {
										if (request[field] && request[field] !== '') {
											fieldElements.push(
												<InputField
													key={field}
													label={program.fieldLabels[field]}
													type="text"
													value={request[field]}
													disabled={true}
												/>
											);
										}
									});
									if (fieldElements.length === 0) return null;
									return (
										<div className="sectionBlock">
											<h2 className="blockHeader">Additional Fields</h2>
											{fieldElements}
										</div>
									);
								})()}

								{additionalAttendees.length > 0 && (
									<div className="sectionBlock">
										<h2 className="blockHeader">Additional Attendees</h2>
										{additionalAttendees.map((attendee, i) => (
											<div className="addtionalAttendeeContainer w-100" key={i}>
												{program.attendeeFieldLabels &&
													Object.keys(program.attendeeFieldLabels).map((field) => (
														<InputField
															key={field}
															label={program.attendeeFieldLabels[field]}
															type="text"
															value={attendee[field]}
															disabled={true}
														/>
													))}
											</div>
										))}
									</div>
								)}

								{salesforceAdditionalAttendees.length > 0 && (
									<div className="sectionBlock">
										<h2 className="blockHeader">Salesforce Additional Attendees</h2>
										{salesforceAdditionalAttendees.map((attendee, i) => {
											let attendeeName = `${attendee.FirstName} ${attendee.LastName}`;
											return (
												<div className="addtionalAttendeeContainer w-100" key={i}>
													<InputField
														label={'Salesforce attendee name'}
														type="text"
														value={attendeeName}
														disabled={true}
													/>
												</div>
											);
										})}
									</div>
								)}

								{salesforceCustomFields.length > 0 && (
									<div className="sectionBlock">
										<h2 className="blockHeader">Salesforce Custom Fields</h2>
										{salesforceCustomFields.map((field, index) => (
											<InputField
												key={index}
												label={field.label || `Field ${index + 1}`}
												value={field.displayValue || field.value}
												disabled={true}
											/>
										))}
									</div>
								)}
							</div>
						);
					}}
					toggle={toggle}
					cancelButtonLabel={'Close'}
				/>
			</div>
		);
	}
}

export default ViewSubmissionModal;
